import { axiosInstance } from '@/lib/axios';
import { CountryModel } from './types';

type Props = {
  companyId: string
}

export function getCountries ({ companyId }: Props) {
    return axiosInstance.get<CountryModel[]>(`/api/${companyId}/country/countries`);
}
